exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".configTable .ant-table-fixed-header .ant-table-header table {\n  visibility: visible !important;\n}\n.configTable .ant-table-fixed-header .ant-table-header table th:first-child {\n  width: 230px;\n  min-width: 200px;\n}\n.configTable .ant-table-fixed-header .ant-table-header table th:nth-child(2) {\n  width: 300px;\n  min-width: 300px;\n}\n.configTable .ant-table-fixed-header .ant-table-header table th.table-cell-scrollbar {\n  width: 0;\n}\n.configTable .ant-table-body::-webkit-scrollbar-track {\n  background: #fafafa;\n}\n.paramTable .ant-table-fixed-header .ant-table-header table {\n  visibility: visible !important;\n}\n.paramTable .ant-table-fixed-header .ant-table-header table th:first-child {\n  width: 200px;\n  min-width: 200px;\n}\n.paramTable .ant-table-fixed-header .ant-table-header table th:nth-child(2) {\n  width: 250px;\n  min-width: 250px;\n}\n.paramTable .ant-table-fixed-header .ant-table-header table th.table-cell-scrollbar {\n  width: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/AntD/assets/stylus/stubParamsConfig.styl
// module id = 4135
// module chunks = 0